import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // WAJIB TAMBAH INI

const firebaseConfig = {
  apiKey: "AIzaSyDT5vmeDLVoqWoW16JpHTITzIKTKU0kq8Y",
  authDomain: "undanga-alfin-ruri.firebaseapp.com",
  projectId: "undanga-alfin-ruri",
  storageBucket: "undanga-alfin-ruri.firebasestorage.app",
  messagingSenderId: "437819385710",
  appId: "1:437819385710:web:0d1b6e5da41c277a40c37f",
};

// 1. Inisialisasi Firebase App
const app = initializeApp(firebaseConfig);

// 2. Inisialisasi Firestore (Database)
const db = getFirestore(app);

// 3. Export 'db' agar bisa dipakai di file Reservasi.jsx
export default db;
